import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { debounce } from "lodash";
import { useCallback, useEffect } from "react";
import { Meta } from "src/@types/paginated";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { useGetJustificationsQuery } from "@/services/justification";
import Table from "../components/table";
import { Create } from "../create";
import { useJustificationFilterActions } from "../ducks/filter/hooks/actions";
import { useFilterState } from "../ducks/filter/hooks/filterState";
import { columns } from "./columns";
import PageError from "components/page-error";
import { handeOrderBy } from "@/utils/pagination";

export const Justification: React.FC = () => {
  const { updateFilter } = useJustificationFilterActions();
  const filterState = useFilterState();

  const { filters } = filterState || { filters: {} };
  const { handleModal } = useDialogModal();
  const orderBy = handeOrderBy(filters.order);

  const { data, isFetching, error } = useGetJustificationsQuery({
    search: filters.search,
    orderBy: JSON.stringify(orderBy),
    meta: {
      page: filters?.meta?.page || 1,
    },
  });

  const { meta, data: justifications } = data || { meta: {}, data: [] };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateFilter({ key: "search", value: event.target.value });
  };

  const debouncedHandleInputChange = useCallback(
    debounce(handleInputChange, 500),
    [],
  );

  const openModalCreate = () => {
    handleModal({
      isOpen: true,
      element: <Create />,
      title: "Adicionar Justificativa",
    });
  };

  useEffect(() => {
    updateFilter({ key: "search", value: "" });
  }, []);

  if (error) {
    return <PageError status={500} message={"ERRO INTERNO NO SERVIDOR"} />;
  }

  return (
    <PageLayout>
      <PageTitle
        title="Gerenciar Justificativas"
        description="Gerencie as justificativas disponíveis para conciliação"
      />
      <ContentContainer>
        <div className="flex flex-col gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
            <div className="w-full">
              <Input
                type="text"
                onChange={debouncedHandleInputChange}
                placeholder="Pesquisar Justificativa"
                className="h-8 bg-white"
              />
            </div>
            <div className="w-full flex justify-end">
              <Button
                variant="default"
                onClick={openModalCreate}
                className="h-8"
              >
                Adicionar Justificativa
              </Button>
            </div>
          </div>
          <Table
            columns={columns}
            meta={meta as Meta}
            data={justifications}
            isFetching={isFetching}
          />
        </div>
      </ContentContainer>
    </PageLayout>
  );
};
